<template>
    <div class="mainBox configBox verbal">
        <div class="mainLeft configTab">
            <div class="title">分组管理</div>
            <ul v-if="leftDataList.length">
                <li
                    v-for="(item, index) in leftDataList"
                    :key="index"
                    :class="left_id == item.id ? 'on' : ''"
                    @click="leftHandler(item.id)"
                >
                    <div>
                        {{ item.title }}
                        <span v-if="item.on_show == 2">隐</span>
                    </div>
                    <i
                        style="color:#ccc"
                        class="el-icon-more"
                        @click.stop="rightClick($event, index, item.is_other)"
                    ></i>
                </li>
                <li class="on" @click="leftDialog = true">
                    添加
                </li>
            </ul>
            <el-empty description="暂无分类" v-else>
                <el-button type="primary" size="mini" @click="leftDialog = true"
                    >添加</el-button
                >
            </el-empty>
            <contextMenu ref="context-menu"></contextMenu>
        </div>
        <div class="mainRight configList">
            <div class="tableTop">
                <div class="operationButton">
                    <el-button
                        type="primary"
                        size="small"
                        @click="advertiseUpdate()"
                        v-if="leftDataList.length"
                        >添加话术</el-button
                    >
                </div>
            </div>
            <el-table
                :data="rightRequestData"
                border
                stripe
                v-loading="isLoading"
            >
                <el-table-column align="center" type="index"></el-table-column>
                <el-table-column prop="id" label v-if="false"></el-table-column>
                <el-table-column prop="title" label="标题"></el-table-column>
                <el-table-column
                    prop="content"
                    label="话术内容"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    prop="on_show"
                    label="状态"
                    width="100"
                    align="center"
                >
                    <el-switch
                        slot-scope="scope"
                        v-model="scope.row.on_show == 1 ? true : false"
                        active-color="#13ce66"
                        inactive-color="#ff4949"
                        @change="
                            listItemUpdate(
                                scope.row.id,
                                'on_show',
                                scope.row.on_show == 1 ? 2 : 1
                            )
                        "
                    ></el-switch>
                </el-table-column>
                <el-table-column
                    prop="sort"
                    label="排序"
                    width="100"
                    align="center"
                ></el-table-column>
                <el-table-column label="操作" width="150" align="center">
                    <div slot-scope="scope" class="operation">
                        <div class="view" @click="advertiseUpdate(scope.row)">
                            更新
                        </div>

                        <div
                            class="danger"
                            @click="advertiseDelete(scope.row.id)"
                        >
                            删除
                        </div>
                    </div>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <div class="tablePage">
                <el-pagination
                    hide-on-single-page
                    background
                    @size-change="sizePage"
                    :current-page.sync="search.page"
                    :page-size="search.limit"
                    :total="search.total"
                    :page-sizes="[15, 20, 25]"
                    layout="total, sizes, prev, pager, next"
                ></el-pagination>
            </div>
        </div>

        <!-- 话术管理修改 -->
        <el-dialog
            title="分组更新"
            custom-class="listDialog"
            width="500px"
            :visible.sync="leftDialog"
            @close="$refs.leftTabForm.resetFields()"
        >
            <el-form
                :model="leftRequestData"
                ref="leftTabForm"
                label-width="100px"
                class="listForm"
            >
                <el-form-item
                    label="标题"
                    prop="title"
                    :rules="[{ required: true, message: '标题不能为空' }]"
                >
                    <el-input v-model="leftRequestData.title"></el-input>
                </el-form-item>
                <el-form-item prop="id" v-show="false">
                    <el-input v-model="leftRequestData.id"></el-input>
                </el-form-item>

                <el-form-item label="排序" prop="sort">
                    <el-input-number
                        v-model="leftRequestData.sort"
                        controls-position="right"
                        :min="0"
                    ></el-input-number>
                </el-form-item>
                <el-form-item label="是否显示" prop="on_show">
                    <el-radio
                        v-model="leftRequestData.on_show"
                        v-for="(item, index) in $const.is_disable"
                        :key="index"
                        :label="item.id"
                        >{{ item.label }}</el-radio
                    >
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button
                    type="primary"
                    size="small"
                    @click="submitForm('leftTabForm')"
                    >确 定</el-button
                >
            </div>
        </el-dialog>

        <!-- 详情修改 -->
        <el-dialog
            title="话术更新"
            custom-class="listDialog"
            width="500px"
            :visible.sync="rightDialog"
            @close="$refs.rightTabForm.resetFields()"
        >
            <el-form
                :model="rtRequestData"
                ref="rightTabForm"
                label-width="100px"
                class="listForm"
            >
                <el-form-item label="分组" prop="group_id">
                    <el-select
                        v-model="rtRequestData.group_id"
                        placeholder="请选择分组"
                        v-if="!rtRequestData.length"
                    >
                        <el-option
                            v-for="item in leftDataList"
                            :key="item.id"
                            :label="item.title"
                            :value="item.id"
                        ></el-option>
                    </el-select>
                    <el-button
                        v-else
                        type="primary"
                        size="mini"
                        @click="
                            leftDialog = true
                            rightDialog = false
                        "
                        >去管理</el-button
                    >
                </el-form-item>
                <el-form-item
                    label="话术标题"
                    prop="title"
                    :rules="[{ required: true, message: '标题不能为空' }]"
                >
                    <el-input v-model="rtRequestData.title"></el-input>
                </el-form-item>
                <el-form-item prop="id" v-show="false">
                    <el-input v-model="rtRequestData.id"></el-input>
                </el-form-item>
                <el-form-item
                    label="话术内容"
                    prop="content"
                    :rules="[{ required: true, message: '内容不能为空' }]"
                >
                    <el-input
                        v-model="rtRequestData.content"
                        type="textarea"
                    ></el-input>
                </el-form-item>
                <el-form-item label="排序" prop="sort">
                    <el-input-number
                        v-model="rtRequestData.sort"
                        controls-position="right"
                        :min="0"
                    ></el-input-number>
                </el-form-item>
                <el-form-item label="是否显示" prop="on_show">
                    <el-radio
                        v-model="rtRequestData.on_show"
                        v-for="(item, index) in $const.is_disable"
                        :key="index"
                        :label="item.id"
                        >{{ item.label }}</el-radio
                    >
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button
                    type="primary"
                    size="small"
                    @click="submitForm('rightTabForm')"
                    >确 定</el-button
                >
            </div>
        </el-dialog>
    </div>
</template>

<script>
import contextMenu from '@/components/contextMenu/index'
export default {
    data() {
        return {
            isLoading: false,
            leftDataList: [],
            left_id: '',
            leftDialog: false,
            leftRequestData: {
                id: '',
                title: '',
                sort: '',
                on_show: 1,
            },
            rightRequestData: [],
            rtRequestData: {
                id: '',
                title: '', //话术标题
                content: '', //话术内容
                sort: '',
                on_show: 1,
                group_id: '',
            },
            rightDialog: false,
            search: {
                total: 0,
                page: 1,
                limit: 15,
            },
        }
    },
    components: {
        contextMenu,
    },
    mounted() {
        this.getInformationList()
    },
    watch: {
        'search.page'() {
            this.getImgList()
        },
        'search.limit'() {
            this.getImgList()
        },
    },
    methods: {
        sizePage(val) {
            this.search.limit = val
        },

        //状态更新
        async listItemUpdate(id, key, value) {
            let param = { id, key, value, operation: true }
            await this.$api.verbalLsInfo(param)
            this.$commonFun.toast('SUCCESS', 'success')
            this.getImgList()
        },
        //话术详情更新
        advertiseUpdate(item) {
            this.rightDialog = true
            if (item) {
                this.$nextTick(() => {
                    this.rtRequestData = JSON.parse(JSON.stringify(item))
                })
            }
            this.$nextTick(() => {
                this.rtRequestData.group_id = this.left_id
            })
        },

        //话术删除
        async advertiseDelete(id) {
            let pageCount = Math.ceil(
                (this.search.total + this.search.limit - 1) / this.search.limit
            )
            await this.$confirm('确定删除该信息？此操作不可逆！', '提示')
            await this.$api.verbalLsDEL({ id })
            this.$commonFun.toast('删除成功', 'success')
            // 最后一页没有数据了，直接向前进1
            if (
                this.rightRequestData.length == 1 &&
                this.search.page !== 1 &&
                pageCount == this.search.page
            ) {
                this.search.page--
                this.getImgList()
            } else {
                this.getImgList()
            }
        },
        //左侧点击
        leftHandler(id, refresh) {
            this.left_id = id
            this.rtRequestData.group_id = id
            this.getImgList(true)
        },

        //左侧右击事件
        rightClick(e, index, is_other) {
            var el = e.currentTarget
            if (is_other == 1) return
            let _self = this

            if (index >= 0) {
                let id = _self.leftDataList[index].id
                let list = [
                    {
                        label: '编辑',
                        icon: 'el-icon-edit',
                        callback(item, done) {
                            done()
                            _self.leftDialog = true
                            _self.$nextTick(() => {
                                _self.leftRequestData = {
                                    ..._self.leftDataList[index],
                                }
                            })
                        },
                    },
                    {
                        label: '删除',
                        icon: 'el-icon-delete',
                        callback(item, done) {
                            done()
                            _self
                                .$confirm(
                                    '确定删除该分类？此操作不可逆！',
                                    '提示'
                                )
                                .then((result) => {
                                    _self.$api
                                        .getVerbalListDel({
                                            id: id,
                                        })
                                        .then((res) => {
                                            _self.leftDataList.splice(index, 1)
                                            _self.$commonFun.toast(
                                                '删除成功',
                                                'success'
                                            )
                                            if (id == _self.left_id) {
                                                _self.left_id =
                                                    _self.leftDataList[0].id
                                            }
                                        })
                                })
                        },
                    },
                ]
                this.$refs['context-menu'].open(e, list)
            }
        },
        async getInformationList() {
            const res = await this.$api.getVerbalList()
            if (res.length) {
                this.leftDataList = res
                this.left_id = res[0].id
                this.rtRequestData.group_id = this.left_id
                this.getImgList()
            }
        },
        async getImgList(refresh) {
            this.isLoading = true
            if (refresh) this.search.page = 1
            let param = {
                ...this.search,
                group_id: this.left_id,
            }
            const date = await this.$api.getVerbalLs(param)
            this.search.total = date.total
            this.rightRequestData = date.data
            this.isLoading = false
        },
        //表单提交
        submitForm(formName) {
            let _self = this
            _self.$commonFun.debounce(() => {
                _self.$refs[formName].validate(async (valid) => {
                    if (!valid) return
                    if (valid) {
                        if (formName == 'leftTabForm') {
                            //广告位信息更新
                            let param = _self.leftRequestData
                            _self.$api.getVerbalListInfo(param).then((res) => {
                                if (param.id) {
                                    //信息更新
                                    _self.leftDataList.forEach(function(
                                        item,
                                        index
                                    ) {
                                        if (item.id == param.id) {
                                            _self.leftDataList[index] = res
                                        }
                                    })
                                } else {
                                    //分类添加
                                    _self.leftDataList.push(res)
                                    if (_self.leftDataList.length == 1) {
                                        _self.left_id = res
                                    }
                                }
                                _self.$commonFun.toast('SUCCESS', 'success')
                                _self.leftDialog = false
                            })
                        } else {
                            let param = { ..._self.rtRequestData }
                            const res = await this.$api.verbalLsInfo(param)
                            _self.rightDialog = false
                            _self.$commonFun.toast('SUCCESS', 'success')
                            this.leftHandler(_self.rtRequestData.group_id)
                            this.getImgList()
                        }
                    }
                })
            })
        },
    },
}
</script>

<style lang="scss">
.verbal {
    .topEnd {
        font-size: 15px;
        margin-bottom: 10px;
        color: #999;
    }
    .operation {
        display: flex;
        align-items: center;
    }
}
</style>
